import React, { FC, useState }         from "react";
import { useDispatch }                 from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteMailGroup                 from "../../../../../application/usecase/mail/group/DeleteMailGroup";
import MailGroup                       from "../../../../../domain/mail/group/MailGroup";

interface Props {
  mailGroup: MailGroup;
}

const MailGroupDeleteButton: FC<Props> = (props: Props) => {
  const {mailGroup} = props;
  const [open, setOpen] = useState(false);
  const deleteMailGroup: DeleteMailGroup = new DeleteMailGroup(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        negative
        onClick={ () => setOpen(true) }
      >
        <Icon name="trash"/>
        削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>メールグループ削除の確認</Modal.Header>
        <Modal.Content>
          <Header as="h5" icon="info circle" dividing content={ `${ mailGroup.name.value }を削除します。` } color="red"/>
          <Modal.Description>
            <p>よろしいですか？</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              deleteMailGroup.execute(mailGroup.id);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailGroupDeleteButton;
